import { useAppSelector } from 'hooks/useAppSelector';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { FormattedMessage } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { FormIdProps } from 'shared/props';
import { missedDealFeedbackReset } from 'state/missed-deal-feeedback/actions';
import { getFeedbackCanBeSubmitted } from 'state/missed-deal-feeedback/selectors';
import { missedDealFeedbackSubmissionRequestedThunk } from 'state/missed-deal-feeedback/thunk';

export function ActionButtons({ formId }: FormIdProps) {
  const canSubmitFeedback = useAppSelector(s => getFeedbackCanBeSubmitted(s, formId));
  const dispatch = useThunkDispatch();
  return (
    <>
      <button
        className="btn btn-xl btn-info"
        data-e2e="missedDealFeedback-submit-button"
        disabled={!canSubmitFeedback}
        onClick={() => {
          dispatch(missedDealFeedbackSubmissionRequestedThunk(formId));
          logAnalytics.trackEvent('Missed Deal Feedback', 'Submit feedback');
        }}
        type="button"
      >
        <FormattedMessage id="form.buttons.Submit" />
      </button>
      <button
        className="btn btn-xl btn-light"
        data-e2e="missedDealFeedback-discard-button"
        onClick={() => {
          dispatch(missedDealFeedbackReset(formId));
          logAnalytics.trackEvent('Missed Deal Feedback', 'Discard feedback');
        }}
        type="button"
      >
        <FormattedMessage id="form.buttons.Discard" />
      </button>
    </>
  );
}
